<template>
  <b-card id="page-orde" no-body class="status-history-card mt-2">
    <b-card-header class="status-history-header">
      <div class="status-history-heading">
        <div class="status-history-icon">
          <feather-icon icon="ActivityIcon" size="19" />
        </div>
        <div>
          <h4 class="mb-25">{{ $t(label("statusManagement")) }}</h4>
          <small class="text-muted">{{ $t(label("statusManagementHelp")) }}</small>
        </div>
      </div>
      <!--  (${ status }) <feather-icon
          icon="MessageSquareIcon"
          size="18"
          class="cursor-pointer"
          variant="success"
          @click="changeChat"
        /> -->

      <b-button
        v-if="option === 2 && !blockStatus"
        variant="flat-dark"
        class="btn-icon ml-auto mr-2"
        size="sm"
        :title="$t('edit')"
        @click="$emit('edit-order')"
      >
        <feather-icon icon="Edit2Icon" size="21" />
      </b-button>
      <b-button
        :aria-expanded="visible ? 'true' : 'false'"
        @click="visible = !visible"
        variant="flat-dark"
        class="btn-icon"
        size="sm"
        :title="$t(label(visible ? 'hideDetails' : 'showDetails'))"
        :class="visible ? null : 'collapsed'"
      >
        <feather-icon :icon="visible ? 'EyeOffIcon' : 'EyeIcon'" size="21" />
      </b-button>
    </b-card-header>

    <b-collapse id="time-line" v-model="visible">
      <b-card-body class="status-history-body pt-0 pb-1">
        <b-row class="status-control-row">
          <b-col
            cols="12"
            sm="12"
            md="6"
            lg="6"
            xl="6"
            v-if="status"
            class="pb-1"
          >
            <v-select
              ref="status"
              v-model="localStatus"
              :options="listOrderStatus"
              input-id="status"
              label="name"
              :placeholder="$t(label('status_order'))"
              :reduce="(option) => option.id"
            >
              <span slot="no-options" click="$refs.status.open = false">
                {{ $t("sorryOption") }}
              </span>
            </v-select>
          </b-col>
          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <b-button
              :disabled="disabledButton"
              variant="primary"
              block
              @click="changeOrderStatus"
            >
              <feather-icon icon="RefreshCwIcon" size="16" class="mr-50" />
              {{ $t(label("update")) }}
            </b-button>
          </b-col>
        </b-row>

        <div class="status-history-label">
          <span>{{ $t(label("statusHistory")) }}</span>
          <b-badge pill variant="light-secondary">{{ histories.length }}</b-badge>
        </div>

        <app-timeline>
          <app-timeline-item
            v-for="(history, index) in histories"
            :id="`history-${index}`"
            :key="index"
            :icon="iconStatus(history.nameStatus)"
            :variant="colorStatus(history.nameStatus)"
          >
            <div
              class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
            >
              <span style="font-size: 14px"> {{ history.nameStatus }} </span>
              <small class="text-muted">{{
                transformDate(history.dateUpdate)
              }}</small>
            </div>
          </app-timeline-item>
        </app-timeline>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BImg,
  BCardHeader,
  BCard,
  BCardTitle,
  BCardBody,
  BAvatar,
  BMedia,
  BButton,
  BCollapse,
  VBToggle,
  BListGroup,
  BListGroupItem,
  BAvatarGroup,
  BBadge,
  VBTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import Ripple from "vue-ripple-directive";
import moment from "moment";
import { getCatalog } from "@core/api/request/catalogs";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";

export default {
  props: {
    option: {
      type: Number,
      default: () => 1,
    },
    blockStatus: {
      type: Boolean,
      default: () => false,
    },
    histories: {
      type: Array,
      default: () => [],
    },
    status: {
      type: Number,
      default: 0,
    },
    nameStatus: {
      type: String,
      default: "",
    },
  },

  components: {
    BCardHeader,
    AppTimeline,
    AppTimelineItem,
    BCard,
    BImg,
    BMedia,
    BAvatar,
    BButton,
    BCollapse,
    BListGroup,
    BListGroupItem,
    BAvatarGroup,
    BBadge,
    BCardTitle,
    BCardBody,
    VBToggle,
    BRow,
    BCol,
    vSelect,
  },
  directives: { "b-toggle": VBToggle, "b-tooltip": VBTooltip, Ripple },
  data() {
    return {
      visible: true,
      listOrderStatus: [],
      disabledButton: false,
      localStatus: null,
    };
  },

  watch: {
    status(a, b) {
      this.localStatus = a;
    },
  },

  created() {
    this.localStatus = this.status;
    this.showCatalog();
  },

  methods: {
    label(field) {
      return `pages.orders.form.label.${field}`;
    },

    iconStatus(status) {
      switch (status) {
        case "Generada":
          return "MessageSquareIcon";
        case "Atendida":
          return "CheckCircleIcon";
        case "Procesada":
          return "ClockIcon";
        case "Terminada":
          return "DollarSignIcon";
        default:
          return "MessageSquareIcon";
      }
    },

    colorStatus(status) {
      switch (status) {
        case "Generada":
          return "secondary";
        case "Atendida":
          return "warning";
        case "Procesada":
          return "info";
        case "Terminada":
          return "success";
        case "Cancelada":
          return "danger";
        default:
          return "primary";
      }
    },

    transformDate(dateString) {
      return moment(dateString).format("DD-MM-YYYY HH:mm A");
    },

    changeOrderStatus() {
      this.$emit("changeStatus", this.localStatus);
    },

    // updatesOrderStatus() {
    //   this.disabledButton = true
    //   if (!this.localStatus) {
    //     this.alertToast("danger", `Alerta`, "Debes seleccionar un estado para actualizar")
    //     this.disabledButton = false
    //     return
    //   }
    //   const data = {
    //     idOrder: item[0].idOrder,
    //     idCatStatus: this.localStatus,
    //   }

    //   changeStatus(data).then(resp => {
    //     console.log(resp)
    //     if (resp.status === 500) {
    //       this.alertToast("danger", `Alerta`, resp.data.message)
    //       this.disabledButton = false
    //       return
    //     }

    //     this.alertToast("success", `Alerta codigo`, resp.data)
    //     this.disabledButton = false
    //     this.$emit('changeorder')
    //   }).catch(error => {
    //     console.log("error", error)
    //     this.loading = !this.loading
    //     this.alertToast("danger", `Alerta codigo`, error.message)
    //   })
    // },

    showCatalog() {
      showLoading();
      const arrParams = getParams([
        `itemsPage,1`,
        `itemsRows,999`,
        `guidCatalog,1a9be8bf-50d7-41b6-b33c-594b0699b1a9`,
      ]);
      getCatalog(arrParams)
        .then((resp) => {
          stopLoading();
          const data = _.get(resp, "data") || [];
          this.listOrderStatus = data.listOfItems.items;
        })
        .catch((error) => {
          stopLoading();
          this.alertToast("danger", error.message);
        });
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },

    changeChat() {
      this.$emit("openChat");
    },
  },
};
</script>

<style lang="scss" scoped>
.status-history-card {
  width: 100%;
  overflow: hidden;
  border: 0;
  border-radius: 0.65rem;
  box-shadow: 0 4px 18px rgba(34, 41, 47, 0.08);
}

.status-history-header {
  padding-bottom: 1rem;
}

.status-history-heading,
.status-history-icon,
.status-history-label {
  display: flex;
  align-items: center;
}

.status-history-heading {
  min-width: 0;
  gap: 0.85rem;
}

.status-history-icon {
  justify-content: center;
  width: 2.65rem;
  height: 2.65rem;
  flex: 0 0 2.65rem;
  color: #ff9f43;
  border-radius: 0.65rem;
  background: rgba(255, 159, 67, 0.12);
}

.status-history-body {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.status-control-row {
  padding: 1rem;
  margin-bottom: 1.25rem;
  border: 1px solid rgba(34, 41, 47, 0.08);
  border-radius: 0.5rem;
  background: rgba(115, 103, 240, 0.035);
}

.status-history-label {
  justify-content: space-between;
  margin-bottom: 1rem;
  color: inherit;
  font-size: 0.9rem;
  font-weight: 600;
}

@media (max-width: 767.98px) {
  .status-history-body {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
</style>
